import { render } from "./EditUserModal.vue?vue&type=template&id=0c4bb068&ts=true"
import script from "./EditUserModal.vue?vue&type=script&lang=ts"
export * from "./EditUserModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__